


























import { ROUTES } from '@/constants/routes';
import Vue from "vue";
import AppCard from "@/components/AppCard.vue";
import { App } from "@/model/App";
export default Vue.extend({
  name: "UserAppList",
  components: { AppCard },
  props: {
    apps: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    navigateToRegisterApp() {
      this.$router.push(ROUTES.REGISTER_APP.path);
    },
  }
});
